//#region src/function/noop.ts
function noop(..._args) {}
//#endregion
export { noop };

//# sourceMappingURL=noop.js.map